<div class="cc">
  <div class="cc__cabecera">
    <span class="cc__icono"><i class="bx bx-lock-alt"></i></span>
    <div class="cc__titulos">
      <h5>Cambio de contraseña</h5>
      <p>Indique su contraseña actual y confirme la nueva.</p>
    </div>
    <button type="button" class="cc__cerrar" (click)="activeModal.dismiss()" aria-label="Cerrar">
      <i class="bx bx-x"></i>
    </button>
  </div>

  <div class="cc__cuerpo" (keydown.enter)="cambiar()">
    <div class="cc__cargando" *ngIf="cargando">Cargando…</div>

    <ng-container *ngIf="!cargando">
      <div class="cc__usuario">
        <i class="bx bx-user"></i>
        <div>
          <strong>{{ usuario }}</strong>
          <span *ngIf="nombre">{{ nombre }}</span>
        </div>
      </div>

      <label class="cc__label" for="ccActual">
        Contraseña actual <small *ngIf="superUsuario">(opcional para super usuario)</small>
      </label>
      <div class="cc__campo" [class.cc__campo--error]="intento && faltaActual">
        <input id="ccActual" [type]="verActual ? 'text' : 'password'" [(ngModel)]="actual" [ngModelOptions]="{standalone: true}"
               autocomplete="off">
        <button type="button" (click)="verActual = !verActual" [attr.aria-label]="verActual ? 'Ocultar' : 'Mostrar'">
          <i class="bx" [class.bx-show]="!verActual" [class.bx-hide]="verActual"></i>
        </button>
      </div>
      <span class="cc__msg" *ngIf="intento && faltaActual">Debe indicar su contraseña actual.</span>

      <label class="cc__label" for="ccNueva">Contraseña nueva</label>
      <div class="cc__campo" [class.cc__campo--error]="intento && faltaNueva">
        <input id="ccNueva" [type]="verNueva ? 'text' : 'password'" [(ngModel)]="nueva" [ngModelOptions]="{standalone: true}"
               autocomplete="off">
        <button type="button" (click)="verNueva = !verNueva" [attr.aria-label]="verNueva ? 'Ocultar' : 'Mostrar'">
          <i class="bx" [class.bx-show]="!verNueva" [class.bx-hide]="verNueva"></i>
        </button>
      </div>
      <span class="cc__msg" *ngIf="intento && faltaNueva">Debe indicar su contraseña nueva.</span>

      <label class="cc__label" for="ccConfirmacion">Confirme la contraseña nueva</label>
      <div class="cc__campo" [class.cc__campo--error]="intento && noCoinciden">
        <input id="ccConfirmacion" [type]="verConfirmacion ? 'text' : 'password'"
               [(ngModel)]="confirmacion" [ngModelOptions]="{standalone: true}" autocomplete="off">
        <button type="button" (click)="verConfirmacion = !verConfirmacion" [attr.aria-label]="verConfirmacion ? 'Ocultar' : 'Mostrar'">
          <i class="bx" [class.bx-show]="!verConfirmacion" [class.bx-hide]="verConfirmacion"></i>
        </button>
      </div>
      <span class="cc__msg" *ngIf="intento && noCoinciden">Las contraseñas no concuerdan.</span>
    </ng-container>

    <div class="cc__error" *ngIf="error" role="alert">
      <i class="bx bx-error-circle"></i>
      <span>{{ error }}</span>
    </div>

    <div class="cc__pie">
      <button type="button" class="cc__btn cc__btn--sec" (click)="activeModal.dismiss()">Cancelar</button>
      <button type="button" class="cc__btn" (click)="cambiar()" [disabled]="cargando || guardando">
        <i class="bx" [class.bx-loader-alt]="guardando" [class.bx-spin]="guardando" [class.bx-check]="!guardando"></i>
        {{ guardando ? 'Guardando…' : 'Cambiar contraseña' }}
      </button>
    </div>
  </div>
</div>
